const GOOGLE_ANALYTICS_ID = "G-KFFNQGVYS3";
const GOOGLE_SCRIPT_ID = "uido-google-analytics";
const PLERDY_SCRIPT_ID = "uido-plerdy";
const PLERDY_SITE_HASH_CODE = "0fda684de5d417437e7d090601291825";
const PLERDY_SUID = 80403;

let isGoogleAnalyticsConfigured = false;

const getConsentState = (prefs) => ({
  ad_storage: prefs.marketing ? "granted" : "denied",
  ad_user_data: prefs.marketing ? "granted" : "denied",
  ad_personalization: prefs.marketing ? "granted" : "denied",
  analytics_storage: prefs.analytics ? "granted" : "denied",
});

const ensureGtag = () => {
  window.dataLayer = window.dataLayer || [];
  window.gtag =
    window.gtag ||
    function gtag() {
      window.dataLayer.push(arguments);
    };
};

const loadGoogleAnalytics = (prefs) => {
  ensureGtag();

  if (!isGoogleAnalyticsConfigured) {
    window.gtag("consent", "default", {
      ad_storage: "denied",
      ad_user_data: "denied",
      ad_personalization: "denied",
      analytics_storage: "denied",
    });
  }

  window.gtag("consent", "update", getConsentState(prefs));

  if (!document.getElementById(GOOGLE_SCRIPT_ID)) {
    const script = document.createElement("script");
    script.id = GOOGLE_SCRIPT_ID;
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GOOGLE_ANALYTICS_ID}`;
    document.head.appendChild(script);
  }

  if (!isGoogleAnalyticsConfigured) {
    window.gtag("js", new Date());
    window.gtag("config", GOOGLE_ANALYTICS_ID, {
      anonymize_ip: true,
    });
    isGoogleAnalyticsConfigured = true;
  }
};

const loadPlerdy = () => {
  if (typeof window.__loadPlerdy === "function") {
    window.__loadPlerdy();
    return;
  }

  if (window.__plerdyCode || document.getElementById(PLERDY_SCRIPT_ID)) return;

  window.__plerdyCode = 1;
  window._protocol = window.location.protocol === "https:" ? "https://" : "http://";
  window._site_hash_code = PLERDY_SITE_HASH_CODE;
  window._suid = PLERDY_SUID;

  const script = document.createElement("script");
  script.id = PLERDY_SCRIPT_ID;
  script.setAttribute("data-plerdy_code", "1");
  script.async = true;
  script.referrerPolicy = "strict-origin-when-cross-origin";
  script.src = `https://a.plerdy.com/public/js/click/main.js?v=${Math.random()}`;
  document.head.appendChild(script);
};

export const applyAnalyticsConsent = (prefs) => {
  if (typeof window === "undefined" || typeof document === "undefined") return;

  if (prefs.analytics) {
    loadGoogleAnalytics(prefs);
    loadPlerdy();
    return;
  }

  if (typeof window.gtag === "function") {
    window.gtag("consent", "update", getConsentState(prefs));
  }
};

export const resetAnalyticsForTests = () => {
  isGoogleAnalyticsConfigured = false;
};
